export const validateForm = (form) => {
  let isValid = true;
  let errors = {email:"",password:""};

  const { email, password } = form;
  if (email != null) {
    if (!email.length) {
      errors = { ...errors, email: "Please enter email" };
      isValid = false;
    }
    if (email && !validateEmail(email)) {
      errors = { ...errors, email: "Please enter valid email (example@gmail.com)" };
      isValid = false;
    }
  }

  if (password != null) {
    if (!password.length) {
      errors.password = "Password can not be empty";
      isValid = false;
    }
    if (password.length && !validatePassword(password)) {
      errors.password = "Password is not valid. password should contain 7-15 characters,atleast one digit and one special character";
      isValid = false;
    }
  }
  return {
    isValid,
    errors,
  };
};

function validateEmail(mail) {
  if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(mail)) {
    return true;
  }
  return false;
}

const validatePassword = (password) => {
  return /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/.test(
    password
  );
};
